<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h5 class="modal-title">End of Session Data</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <div class="form-grid">
          <div class="form-group">
            <label>Post-Dialysis Weight (kg):</label>
            <input v-model="form.post_weight" type="number" step="0.1" />
          </div>

          <div class="form-group">
            <label>Blood Pressure (mmHg):</label>
            <input v-model="form.bp" type="text" placeholder="e.g. 120/80" />
          </div>

          <div class="form-group">
            <label>Pulse Rate (bpm):</label>
            <input v-model="form.pulse" type="number" />
          </div>

          <div class="form-group">
            <label>Respiratory Rate (breaths/min):</label>
            <input v-model="form.resp" type="number" />
          </div>

          <div class="form-group">
            <label>Temperature (°C):</label>
            <input v-model="form.temp" type="number" step="0.1" />
          </div>

          <div class="form-group">
            <label>Total Fluid Removed (ml):</label>
            <input v-model="form.total_removed" type="number" />
          </div>

          <!-- <div class="form-group">
            <label>Session Start Time:</label>
            <input v-model="form.start_time" type="time" />
          </div>

          <div class="form-group">
            <label>Session End Time:</label>
            <input v-model="form.end_time" type="time" />
          </div> -->

          <div class="form-group">
            <label>Elapsed Time (min):</label>
            <input v-model="form.elapsed_time" type="number" min="0" />
          </div>

          <div class="form-group">
            <label>Remaining Time (if stopped early) (min):</label>
            <input v-model="form.remaining_time" type="number" min="0" />
          </div>
        </div>

        <div class="form-group">
          <label>Complications Encountered:</label>
          <textarea v-model="form.complications" rows="2"></textarea>
        </div>

        <div class="form-group">
          <label>Actions Taken:</label>
          <textarea v-model="form.actions" rows="2"></textarea>
        </div>

        <div class="form-group">
          <label>Medications Administered:</label>
          <textarea v-model="form.medications" rows="2"></textarea>
        </div>

        <div class="form-group">
          <label>Machine Disinfection Cycle Confirmed:</label>
          <select v-model="form.disinfection_done">
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="Not done">Not done</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="closeModal">
            Cancel
          </button>
          <button type="button" class="btn-primary" @click="saveSessionData">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getDialysisTymes from "./dialysis_tymes";
import loader from "./loader.vue";
import getElapsedMinutes from "./lapsed_minutes";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "EndSessionModal",
  data() {
    return {
      loading: false,
      form: {
        session_id: "",
        post_weight: "",
        bp: "",
        pulse: "",
        resp: "",
        temp: "",
        total_removed: "",
        start_time: "",
        end_time: "",
        elapsed_time: "",
        remaining_time: "",
        complications: "",
        actions: "",
        medications: "",
        disinfection_done: "",
      },
    };
  },
  components: {
    loader,
  },
  props: {
    session_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-end-session-modal");
    },
    async loadElapsedMinutes() {
      this.loading = true;
      try {
        const minutes = await getElapsedMinutes(this.session_id);
        this.form.elapsed_time = minutes;
      } finally {
        this.loading = false;
      }
    },

    async get_times() {
      const times = await getDialysisTymes(this.session_id);
      this.form.end_time = times.current_time;
      this.form.start_time = times.start_time_utc;
    },
    async saveSessionData() {
      this.loading = true;
      console.log(this.form);

      try {
        this.form.session_id = this.session_id;

        const response = await generalApiRequest(
          "dialysis/end-session",
          "POST",
          this.form,
          1
        );

        console.log(response);
        this.closeModal();
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadElapsedMinutes();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  border: none;
  color: white;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  border-radius: 0.3rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.45rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
  box-sizing: border-box;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.btn-primary {
  background: #2786f7;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-secondary {
  background: #bbb;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
